//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  name: "yuyue",
  data(){
    return{
      // 日期列表
      dateList:[],
      // 时间段列表
      timeList:[],
      // 选择日期的下标
      is_active_day:0,
      // 选择日期实际时间参数
      appoint_time:'',
      // 选择时间段下标
      is_active_time:null,
      // 选择时间段对象
      active_time:'',
      // 备注
      value_textarea:"",
      // 店铺名称
      store_name:'',
      // 店铺id
      sid:'',
      // 预约的项目对象
      yuyue:'',
    }
  },
  created(){
    let sid = this.$route.params.sid
    this.sid = this.$route.params.sid
    this.yuyue =this.$route.params.yuyue
    // console.log(this.yuyue);
    this.getDateList()
    this.getStore(sid)  
  },
  methods:{
    // 获取一周日期
    async getDateList(){
      let res = await this.$HTTP.HttpPost("/member/appointment/getDate", {})
      this.dateList = res.data.data
      this.appoint_time = this.dateList[0].appoint_time
      this.getTimes(this.sid)
    },
    // 获取时间段
    async getTimes(id){
      let data ={
        sid:id,
        appoint_time:this.appoint_time
      }
      let res = await this.$HTTP.HttpPost("/member/appointment/getTime", data)
      // console.log(res.data.data);
      this.timeList = res.data.data
    },
    // 切换日期
    onChageDay(i,item){
      if(this.is_active_day != i){
        this.is_active_day = i
        this.appoint_time = item.appoint_time 
        this.getTimes(this.sid)
      }
    },
    // 选择时间段
    onChangeCard(count,i,item){
      if(count > 0){
        this.is_active_time = i
        this.active_time = item
      }
    },
    // 获取店铺列表 当前店铺名称
    async getStore(sid){
     let res =   await this.$HTTP.HttpPost("/Member/Appointment/getStoreSelect", {})
     let datalist = res.data.data
     for(let i = 0; i < datalist.length; i++){
       if(datalist[i].id == sid){
         this.store_name = datalist[i].store_name
       }
     }
    },
    // 确认预约
    async onYuyue(){
      let data = {
        item_name: this.yuyue[0].service_item_name,
        item_id: this.yuyue[0].id,
        sid:this.sid,
        appoint_time:this.appoint_time,
        time_id:this.active_time.id,
        remark:this.value_textarea,
      }
      // console.log(data);
      let res =   await this.$HTTP.HttpPost("/member/appointment/appointment", data)
      if(res.data.code == 200){
        this.$vux.toast.show({
          text: res.data.msg,
          type: "text",
          width: "80%",
          isShowMask: true,
        })
        this.$router.push({
          name: "/yuyuedingdan"
        });
      }else{
        this.$vux.toast.show({
          text: res.data.msg,
          type: "text",
          width: "80%",
          isShowMask: true,
        })
      }
      this.getTimes(this.sid)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/yuyue.vue